import React, { Component } from 'react';
import Vas from '../Vas';
import $ from 'jquery';
import '../css/Order.css';
import { CurrencyConverter } from 'utils-lib';

var Customer = null;
var Payment = null;
var From = null;
var To = null;
var Product = null;
var ContractStart = null;
var ContractEnd = null;
var DateOfBirth = null;
var LegalGuardian = null;
var LegalGuardianBirthDate = null;
var AccountOwner = null;
var AtgFrom = null;
var AtgTo = null;
//var AccountOwnerBirthDate = null;

class OrderSuccess extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};

        //Hier die Infos für die Vertragsübersicht auslesen
        DateOfBirth = localStorage.getItem('ContractOverviewCustomerBirthdate');
        Customer = JSON.parse(localStorage.getItem('ContractOverviewCustomer'));
        Payment = JSON.parse(localStorage.getItem('ContractOverviewCustomerPayment'));
        From = JSON.parse(localStorage.getItem('ContractOverviewTariffPointFrom'));
        To = JSON.parse(localStorage.getItem('ContractOverviewTariffPointTo'));
        Product = JSON.parse(localStorage.getItem('ContractOverviewTariffProduct'));
        ContractStart = localStorage.getItem('ContractOverviewContractStart');
        ContractEnd = localStorage.getItem('ContractOverviewContractEnd');
        LegalGuardian = JSON.parse(localStorage.getItem('LegalGuardian'));
        LegalGuardianBirthDate = localStorage.getItem('LegalGuardianBirthDate');
        AccountOwner = JSON.parse(localStorage.getItem('AccountOwner'));
        //AccountOwnerBirthDate = localStorage.getItem('AccountOwnerBirthDate');

        //Hier das ATG zu den Tarifpunkten ermitteln
        AtgFrom = localStorage.getItem('ContractOverviewTariffPointFromAtg');
        AtgTo = localStorage.getItem('ContractOverviewTariffPointToAtg');

        //Hier die Angaben zur Vertragsanlage löschen, da der Dokumentenupload ebenfalls erfolgreich war
        localStorage.removeItem("CustomerId");
        localStorage.removeItem("ContractNUmber");
        localStorage.removeItem("ExecutingForm");
    }

    componentDidMount(){
      Vas.clearLocalStorage();

      this.FontSizeClick();
          
    }

    FontSizeClick(){
      var schriftgröße = localStorage.getItem('Schriftgröße');

      //Schriftgröße bei Klick in 2er Schritten erhöhen

        if(schriftgröße != null){

          switch(schriftgröße){
            case "0":
              $("#PersonalData_NameHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#PersonalData_Name").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#PersonalData_FirstNameHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#PersonalData_FirstName").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#PersonalData_DateOfBirthHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#PersonalData_DateOfBirth").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#PersonalData_GenderHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#PersonalData_Name").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#PersonalData_NameHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#PersonalData_Gender").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#PersonalData_EmailHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#PersonalData_Email").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#PersonalData_ZipHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#PersonalData_Zip").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#PersonalData_PlaceHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#PersonalData_Place").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#PersonalData_StreetHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#PersonalData_Street").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#PersonalData_HousenumberHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#PersonalData_Housenumber").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#PersonalData_HousenumberAdditionHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#PersonalData_HousenumberAddition").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#PersonalData_AdditionAddressHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#PersonalData_AdditionAddress").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#ContractData_ContractStartHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#ContractData_ContractStart").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#ContractData_ContractEndHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#ContractData_ContractEnd").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#ContractData_ProductPriceHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#ContractData_ProductPrice").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#ContractData_PriceLevelHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#ContractData_PriceLevel").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#ContractData_TicketNameHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#ContractData_TicketName").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#ContractData_DepositorHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#ContractData_Depositor").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#ContractData_NameOfBankHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#ContractData_NameOfBank").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#ContractData_IbanHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
              $("#ContractData_Iban").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      

                break;
            case "1":
              $("#PersonalData_NameHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#PersonalData_Name").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#PersonalData_FirstNameHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#PersonalData_FirstName").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#PersonalData_DateOfBirthHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#PersonalData_DateOfBirth").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#PersonalData_GenderHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#PersonalData_Name").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#PersonalData_NameHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#PersonalData_Gender").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#PersonalData_EmailHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#PersonalData_Email").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#PersonalData_ZipHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#PersonalData_Zip").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#PersonalData_PlaceHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#PersonalData_Place").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#PersonalData_StreetHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#PersonalData_Street").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#PersonalData_HousenumberHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#PersonalData_Housenumber").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#PersonalData_HousenumberAdditionHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#PersonalData_HousenumberAddition").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#PersonalData_AdditionAddressHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#PersonalData_AdditionAddress").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#ContractData_ContractStartHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#ContractData_ContractStart").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#ContractData_ContractEndHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#ContractData_ContractEnd").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#ContractData_ProductPriceHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#ContractData_ProductPrice").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#ContractData_PriceLevelHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#ContractData_PriceLevel").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#ContractData_TicketNameHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#ContractData_TicketName").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#ContractData_DepositorHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#ContractData_Depositor").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#ContractData_NameOfBankHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#ContractData_NameOfBank").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#ContractData_IbanHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
              $("#ContractData_Iban").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");

                break;
            case "2":
              $("#PersonalData_NameHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#PersonalData_Name").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#PersonalData_FirstNameHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#PersonalData_FirstName").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#PersonalData_DateOfBirthHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#PersonalData_DateOfBirth").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#PersonalData_GenderHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#PersonalData_Name").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#PersonalData_NameHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#PersonalData_Gender").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#PersonalData_EmailHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#PersonalData_Email").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#PersonalData_ZipHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#PersonalData_Zip").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#PersonalData_PlaceHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#PersonalData_Place").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#PersonalData_StreetHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#PersonalData_Street").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#PersonalData_HousenumberHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#PersonalData_Housenumber").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#PersonalData_HousenumberAdditionHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#PersonalData_HousenumberAddition").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#PersonalData_AdditionAddressHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#PersonalData_AdditionAddress").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#ContractData_ContractStartHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#ContractData_ContractStart").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#ContractData_ContractEndHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#ContractData_ContractEnd").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#ContractData_ProductPriceHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#ContractData_ProductPrice").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#ContractData_PriceLevelHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#ContractData_PriceLevel").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#ContractData_TicketNameHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#ContractData_TicketName").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#ContractData_DepositorHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#ContractData_Depositor").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#ContractData_NameOfBankHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#ContractData_NameOfBank").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#ContractData_IbanHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
              $("#ContractData_Iban").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");

                break;
            case "3":
              $("#PersonalData_NameHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#PersonalData_Name").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#PersonalData_FirstNameHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#PersonalData_FirstName").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#PersonalData_DateOfBirthHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#PersonalData_DateOfBirth").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#PersonalData_GenderHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#PersonalData_Name").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#PersonalData_NameHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#PersonalData_Gender").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#PersonalData_EmailHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#PersonalData_Email").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#PersonalData_ZipHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#PersonalData_Zip").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#PersonalData_PlaceHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#PersonalData_Place").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#PersonalData_StreetHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#PersonalData_Street").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#PersonalData_HousenumberHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#PersonalData_Housenumber").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#PersonalData_HousenumberAdditionHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#PersonalData_HousenumberAddition").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#PersonalData_AdditionAddressHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#PersonalData_AdditionAddress").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#ContractData_ContractStartHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#ContractData_ContractStart").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#ContractData_ContractEndHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#ContractData_ContractEnd").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#ContractData_ProductPriceHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#ContractData_ProductPrice").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#ContractData_PriceLevelHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#ContractData_PriceLevel").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#ContractData_TicketNameHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#ContractData_TicketName").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#ContractData_DepositorHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#ContractData_Depositor").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#ContractData_NameOfBankHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#ContractData_NameOfBank").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#ContractData_IbanHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
              $("#ContractData_Iban").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                break;
            case "4":
              $("#PersonalData_NameHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#PersonalData_Name").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#PersonalData_FirstNameHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#PersonalData_FirstName").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#PersonalData_DateOfBirthHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#PersonalData_DateOfBirth").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#PersonalData_GenderHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#PersonalData_Name").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#PersonalData_NameHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#PersonalData_Gender").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#PersonalData_EmailHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#PersonalData_Email").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#PersonalData_ZipHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#PersonalData_Zip").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#PersonalData_PlaceHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#PersonalData_Place").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#PersonalData_StreetHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#PersonalData_Street").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#PersonalData_HousenumberHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#PersonalData_Housenumber").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#PersonalData_HousenumberAdditionHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#PersonalData_HousenumberAddition").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#PersonalData_AdditionAddressHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#PersonalData_AdditionAddress").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#ContractData_ContractStartHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#ContractData_ContractStart").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#ContractData_ContractEndHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#ContractData_ContractEnd").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#ContractData_ProductPriceHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#ContractData_ProductPrice").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#ContractData_PriceLevelHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#ContractData_PriceLevel").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#ContractData_TicketNameHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#ContractData_TicketName").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#ContractData_DepositorHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#ContractData_Depositor").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#ContractData_NameOfBankHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#ContractData_NameOfBank").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#ContractData_IbanHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
              $("#ContractData_Iban").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

                break;
            case "5":
              $("#PersonalData_NameHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#PersonalData_Name").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#PersonalData_FirstNameHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#PersonalData_FirstName").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#PersonalData_DateOfBirthHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#PersonalData_DateOfBirth").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#PersonalData_GenderHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#PersonalData_Name").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#PersonalData_NameHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#PersonalData_Gender").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#PersonalData_EmailHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#PersonalData_Email").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#PersonalData_ZipHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#PersonalData_Zip").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#PersonalData_PlaceHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#PersonalData_Place").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#PersonalData_StreetHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#PersonalData_Street").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#PersonalData_HousenumberHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#PersonalData_Housenumber").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#PersonalData_HousenumberAdditionHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#PersonalData_HousenumberAddition").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#PersonalData_AdditionAddressHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#PersonalData_AdditionAddress").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#ContractData_ContractStartHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#ContractData_ContractStart").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#ContractData_ContractEndHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#ContractData_ContractEnd").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#ContractData_ProductPriceHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#ContractData_ProductPrice").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#ContractData_PriceLevelHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#ContractData_PriceLevel").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#ContractData_TicketNameHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#ContractData_TicketName").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#ContractData_DepositorHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#ContractData_Depositor").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#ContractData_NameOfBankHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#ContractData_NameOfBank").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#ContractData_IbanHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
              $("#ContractData_Iban").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                break;
          }           
        }
    }

   render()
    {

      let PersonalData = '';
      let PersonalDataLegalGuardian = '';
      let ContractData = '';
      let AccountOwnerData = '';

      if(Customer !== null){
        PersonalData = (<table>
          <tbody>
            <tr>
              <td colSpan={5}>
                <br/>
                <br/>
                  <div id={"ContractDataHeadline"}>
                    <b>{Vas.Resources.Labels["Account"]} {Vas.Resources.Labels["TicketCustomer"]}</b>
                  </div>
                <br/>
                <br/>
              </td>
            </tr>
            <tr>
              <td>
                <div id={"PersonalData_LeftContainer"}>
                  <div id={"PersonalData_NameHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Name"]}:</b></div>

                  <div id={"PersonalData_Name"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{Customer.Name1}</div>
                </div>

                <div id={"PersonalData_Empty"}></div>

                <div id={"PersonalData_RightContainer"}>
                  <div id={"PersonalData_FirstNameHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["FirstName"]}:</b></div>

                  <div id={"PersonalData_FirstName"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ Customer.Name2 }</div>
                </div>  
              </td>
            </tr>
  
            <tr>
              <td>
                <div id={"PersonalData_LeftContainer"}>
                  <div id={"PersonalData_DateOfBirthHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["DateOfBirth"]}:</b></div>

                  <div id={"PersonalData_DateOfBirth"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ DateOfBirth }</div>
                </div>

                <div id={"PersonalData_Empty"}></div>

                <div id={"PersonalData_RightContainer"}>
                  <div id={"PersonalData_GenderHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Gender"]}:</b></div>

                  <div id={"PersonalData_Gender"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ Customer.Gender }</div>
                </div>  
              </td>
            </tr>
  
            <tr>
              <td>
                <div id={"PersonalData_LeftContainer"}>
                  <div id={"PersonalData_EmailHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Email"]}:</b></div>

                  <div id={"PersonalData_Email"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ Customer.Email }</div>
                </div>

                <div id={"PersonalData_Empty"}></div>

                <div id={"PersonalData_RightContainer_Empty"}>
                  <div></div>
  
                  <div></div>
                </div>  
              </td>
            </tr>
  
            <tr>
              <td>
                <div id={"PersonalData_LeftContainer"}>
                  <div id={"PersonalData_ZipHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Zip"]}:</b></div>
 
                  <div id={"PersonalData_Zip"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{Customer.PostCode}</div>
                </div>

                <div id={"PersonalData_Empty"}></div>

                <div id={"PersonalData_RightContainer"}>
                  <div id={"PersonalData_PlaceHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Place"]}:</b></div>

                  <div id={"PersonalData_Place"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ Customer.City }</div>
                </div>  
              </td>
            </tr>
  
            <tr>
              <td>
                <div id={"PersonalData_LeftContainer"}>
                  <div id={"PersonalData_StreetHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Street"]}:</b></div>
              
                  <div id={"PersonalData_Street"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ Customer.Street }</div>
                </div>

                <div id={"PersonalData_Empty"}></div>

                <div id={"PersonalData_RightContainer_Empty"}>
                  <div></div>

                  <div></div>
                </div>
              </td>
            </tr>
  
            <tr>
              <td>
                <div id={"PersonalData_LeftContainer"}>
                  <div id={"PersonalData_HousenumberHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["HouseNumber"]}:</b></div>

                  <div id={"PersonalData_Housenumber"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ Customer.HouseNumber }</div>
                </div>

                <div id={"PersonalData_Empty"}></div>

                <div id={"PersonalData_RightContainer"}>
                  <div id={"PersonalData_HousenumberAdditionHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["HouseNumberAddition"]}:</b></div>

                  <div id={"PersonalData_HousenumberAddition"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ Customer.HouseNumberAddition }</div>
                </div>  
              </td>
            </tr>
  
            <tr>
              <td>
                <div id={"PersonalData_LeftContainer"}>

                  <div id={"PersonalData_AdditionAddressHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["AdditionAdress"]}:</b></div>

                  <div id={"PersonalData_AdditionAddress"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ Customer.Name3 }</div>

                </div>

                <div id={"PersonalData_Empty"}></div>

                <div id={"PersonalData_RightContainer_Empty"}>
                  <div></div>

                  <div></div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>);
      }

      if(LegalGuardian !== null){
        PersonalDataLegalGuardian = (<table>
          <tbody>
            <tr>
              <td colSpan={5}>
                <br/>
                <br/>
                <div id={"PersonalDataLegalGuardianHeadline"}>
                  <b>Persönliche Daten gesetzl. Vertreter</b>
                </div>
                <br/>
                <br/>
              </td>
            </tr>
            <tr>
              <td>
                <div id={"PersonalDataLegalGuardian_LeftContainer"}>
                  <div id={"PersonalDataLegalGuardian_NameHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Name"]}:</b></div>

                  <div id={"PersonalDataLegalGuardian_Name"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{LegalGuardian.Name1}</div>
                </div>

                <div id={"PersonalDataLegalGuardian_Empty"}></div>

                <div id={"PersonalDataLegalGuardian_RightContainer"}>

                  <div id={"PersonalDataLegalGuardian_FirstNameHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["FirstName"]}:</b></div>

                  <div id={"PersonalDataLegalGuardian_FirstName"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ LegalGuardian.Name2 }</div>
                </div>
              </td>
            </tr>
  
            <tr>
              <td>
              <div id={"PersonalDataLegalGuardian_LeftContainer"}>
                <div id={"PersonalDataLegalGuardian_DateOfBirthHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["DateOfBirth"]}:</b></div>

                <div id={"PersonalDataLegalGuardian_DateOfBirth"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ LegalGuardianBirthDate }</div>
                </div>

                <div id={"PersonalDataLegalGuardian_Empty"}></div>

                <div id={"PersonalDataLegalGuardian_RightContainer"}>
                  <div id={"PersonalDataLegalGuardian_GenderHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Gender"]}:</b></div>

                  <div id={"PersonalDataLegalGuardian_Gender"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ LegalGuardian.Gender }</div>
                </div>
              </td>
            </tr>
  
            <tr>
              <td>
              <div id={"PersonalDataLegalGuardian_LeftContainer"}>
                <div id={"PersonalDataLegalGuardian_EmailHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Email"]}:</b></div>

                <div id={"PersonalDataLegalGuardian_Email"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ LegalGuardian.Email }</div>
                </div>

                <div id={"PersonalDataLegalGuardian_Empty"}></div>

                <div id={"PersonalDataLegalGuardian_RightContainer_Empty"}>
                  <div></div>

                  <div></div>
                </div>
              </td>
            </tr>
  
  
            <tr>
              <td>
              <div id={"PersonalDataLegalGuardian_LeftContainer"}>
                <div id={"PersonalDataLegalGuardian_PostCodeHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Zip"]}:</b></div>

                <div id={"PersonalDataLegalGuardian_Zip"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{LegalGuardian.PostCode}</div>
                </div>

                <div id={"PersonalDataLegalGuardian_Empty"}></div>

                <div id={"PersonalDataLegalGuardian_RightContainer"}>
                  <div id={"PersonalDataLegalGuardian_PlaceHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Place"]}:</b></div>

                  <div id={"PersonalDataLegalGuardian_Place"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ LegalGuardian.City }</div>
                </div>
              </td>
            </tr>
  
            <tr>
              <td>
              <div id={"PersonalDataLegalGuardian_LeftContainer"}>
                <div id={"PersonalDataLegalGuardian_StreetHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Street"]}:</b></div>

                <div id={"PersonalDataLegalGuardian_Street"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ LegalGuardian.Street }</div>
                </div>

                <div id={"PersonalDataLegalGuardian_Empty"}></div>

                <div id={"PersonalDataLegalGuardian_RightContainer_Empty"}>
                  <div></div>

                  <div></div>
                </div>
              </td>
            </tr>
  
            <tr>
              <td>
              <div id={"PersonalDataLegalGuardian_LeftContainer"}>
                <div id={"PersonalDataLegalGuardian_HouseNumberHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["HouseNumber"]}:</b></div>

                <div id={"PersonalDataLegalGuardian_HouseNumber"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ LegalGuardian.HouseNumber }</div>
                </div>

                <div id={"PersonalDataLegalGuardian_Empty"}></div>

                <div id={"PersonalDataLegalGuardian_RightContainer"}>
                  <div id={"PersonalDataLegalGuardian_HouseNumberAdditionHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["HouseNumberAddition"]}:</b></div>

                  <div id={"PersonalDataLegalGuardian_HouseNumberAddition"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ LegalGuardian.HouseNumberAddition }</div>
                </div>
              </td>
            </tr>
  
            <tr>
              <td>
              <div id={"PersonalDataLegalGuardian_LeftContainer"}>
                <div id={"PersonalDataLegalGuardian_AdditionAdressHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["AdditionAdress"]}:</b></div>
 
                <div id={"PersonalDataLegalGuardian_AdditionAdress"} style={{ fontSize:'14px', textAlign: 'left', float:'right' }}>{ LegalGuardian.Name3 }</div>
                </div>

                <div id={"PersonalDataLegalGuardian_Empty"}></div>

                <div id={"PersonalDataLegalGuardian_RightContainer_Empty"}>
                  <div></div>

                  <div></div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>);
      }

      if(AccountOwner !== null){
        AccountOwnerData = (<table>
          <tbody>
            <tr>
              <td colSpan={5}>
                <br/>
                <br/>
                <div id={"AccountOwnerDataHeadline"}>
                  <b>Persönliche Daten Kontoinhaber</b>
                </div>
                <br/>
                <br/>
              </td>
            </tr>
             
             <tr>
               <td>
               <div id={"AccountOwnerData_LeftContainer"}>
                  <div id={"AccountOwnerData_GenderHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Gender"]}:</b></div>
                
                  <div id={"AccountOwnerData_Gender"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{AccountOwner.Gender}</div>

                </div>
               </td>
             </tr>
            <tr>
              <td>
                <div id={"AccountOwnerData_LeftContainer"}>
                  <div id={"AccountOwnerData_ZipHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Zip"]}:</b></div>
                
                  <div id={"AccountOwnerData_Zip"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{AccountOwner.PostCode}</div>

                </div>

                <div id={"AccountOwnerData_Empty"}></div>

                <div id={"AccountOwnerData_RightContainer"}>

                  <div id={"AccountOwnerData_PlaceHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Place"]}:</b></div>

                  <div id={"AccountOwnerData_Place"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ AccountOwner.City }</div>
                </div>
              </td>
            </tr>
  
            <tr>
              <td>
                <div id={"AccountOwnerData_LeftContainer"}>
                  <div id={"AccountOwnerData_StreetHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Street"]}:</b></div>

                  <div id={"AccountOwnerData_Street"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ AccountOwner.Street }</div>
                  </div>

                <div id={"AccountOwnerData_Empty"}></div>

                <div id={"AccountOwnerData_RightContainer_Empty"}>

                  <div></div>

                  <div></div>
                </div>
              </td>
            </tr>
  
            <tr>
              <td>
                <div id={"AccountOwnerData_LeftContainer"}>
                  <div id={"AccountOwnerData_HouseNumberHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["HouseNumber"]}:</b></div>

                  <div id={"AccountOwnerData_HouseNumber"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ AccountOwner.HouseNumber }</div>
                </div>

                <div id={"AccountOwnerData_Empty"}></div>

                <div id={"AccountOwnerData_RightContainer"}>

                  <div id={"AccountOwnerData_HouseNumberAdditionHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["HouseNumberAddition"]}:</b></div>

                  <div id={"AccountOwnerData_HouseNumberAddition"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ AccountOwner.HouseNumberAddition }</div>
                </div>
              </td>
            </tr>
  
            <tr>
              <td>
                <div id={"AccountOwnerData_LeftContainer"}>
                  <div id={"AccountOwnerData_AdditionAdressHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["AdditionAdress"]}:</b></div>

                  <div id={"AccountOwnerData_AdditionAdress"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ AccountOwner.Name3 }</div>

                </div>

                <div id={"AccountOwnerData_Empty"}></div>

                <div id={"AccountOwnerData_RightContainer_Empty"}>

                  <div></div>
                
                  <div></div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>);
      }

      if(Payment !== null && From !== null && To !== null && Product !== null){

        let fromZone = AtgFrom == null ? Product.TzFromText == undefined ? From.DescriptionLong : Product.TzFromText : AtgFrom;
        let toZone = AtgTo == null ? Product.TzToText == undefined ? To.DescriptionLong : Product.TzToText : AtgTo;

        let connectionData = "";
        let fromToConnectionData = "";
        let viaConnectionData = "";
        let validInData = "";

        if((fromZone !== '' && fromZone !== 'null') && 
          !(Product.TicketIdent == "01-37-02" || 
          Product.TicketIdent == "01-45-02" || 
          Product.TicketIdent == "01-43-02" || 
          Product.TicketIdent == "01-47-02")){
            connectionData = (<tr>
              <td colSpan={5}>
                <br/>
                <br/>
                <div id={"ContractDataConnectionHeadline"}>
                  <b>{Vas.Resources.Labels["ConnectionData"]}</b>
                </div>
                <br/>
                <br/>
              </td>
            </tr>);

            if(Product.TicketIdent == "01-35-02" || 
            Product.TicketIdent == "01-38-02"){
              if(fromZone == toZone){

                if(Product.PriceLevel == "kleiner Stadtverkehr"){
                  validInData = (<tr>
                    <td>
                      <div id={"ContractData_LeftContainer"}>
                        <div id={"ContractData_ViaHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>Gültig in:</b></div>
            
                        <div id={"ContractData_Via"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ Product.PriceLevel + " (" + From.DescriptionShort + ")" }</div>
                      </div>
            
                      <div id={"ContractData_Empty"}></div>
            
                      <div id={"ContractData_RightContainer_Empty"}>
                        <div></div>
            
                        <div></div>
                      </div>
                    </td>
                  </tr>);
                }else{
                  validInData = (<tr>
                    <td>
                      <div id={"ContractData_LeftContainer"}>
                        <div id={"ContractData_ViaHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>Gültig in:</b></div>
            
                        <div id={"ContractData_Via"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ "Zone " + fromZone}</div>
                      </div>
            
                      <div id={"ContractData_Empty"}></div>
            
                      <div id={"ContractData_RightContainer_Empty"}>
                        <div></div>
            
                        <div></div>
                      </div>
                    </td>
                  </tr>);
                }
              }

            } else {
              fromToConnectionData = (<tr>
                <td>
                  <div id={"ContractData_LeftContainer"}>
                    <div id={"ContractData_FromHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["From"]}:</b></div>
        
                    <div id={"ContractData_From"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ "Zone " + fromZone}</div>
                  </div>
          
                  <div id={"ContractData_Empty"}></div>
          
                  <div id={"ContractData_RightContainer"}>
                    <div id={"ContractData_ToHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left'}}><b>{Vas.Resources.Labels["To"]}:</b></div>
          
                    <div id={"ContractData_To"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ "Zone " + toZone}</div>
                  </div>
                </td>
              </tr>);
  
              viaConnectionData = (<tr>
                <td>
                  <div id={"ContractData_LeftContainer"}>
                    <div id={"ContractData_ViaHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Via"]}:</b></div>
        
                    <div id={"ContractData_Via"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ Product.TzViaText }</div>
                  </div>
        
                  <div id={"ContractData_Empty"}></div>
        
                  <div id={"ContractData_RightContainer_Empty"}>
                    <div></div>
        
                    <div></div>
                  </div>
                </td>
              </tr>);
            }
        }

        ContractData = (<table>
          <tbody>
            <tr>
              <td
                colSpan={5}>
                  <br/>
                  <br/>
                  <div id={"ContractDataHeadline"}>
                    <b>{Vas.Resources.Labels["ContractData"]}</b>
                  </div>
                  <br/>
                  <br/>
                  </td>
            </tr>
            <tr>
              <td>
                <div id={"ContractData_LeftContainer"}>
                  <div id={"ContractData_ContractStartHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["ContractStart"]}:</b></div>

                  <div id={"ContractData_ContractStart"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ContractStart}</div>
                </div>

                <div id={"ContractData_Empty"} ></div>

                <div id={"ContractData_RightContainer"}>
                  <div id={"ContractData_ContractEndHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["ContractEnd"]}:</b></div>

                  <div id={"ContractData_ContractEnd"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ContractEnd }</div>

                </div>
              </td>
            </tr>
  
            <tr>
              <td>
                <div id={"ContractData_LeftContainer"}>
                  <div id={"ContractData_ProductPriceHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["ProductPrice"]}:</b></div>

                  <div id={"ContractData_ProductPrice"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ CurrencyConverter.Cast( Product.Price, localStorage.getItem("vas_language") ,2) }</div>
                </div>

                <div id={"ContractData_Empty"}></div>

                <div id={"ContractData_RightContainer"}>
                  <div id={"ContractData_PriceLevelHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["PriceLevel"]}:</b></div>
  
                  <div id={"ContractData_PriceLevel"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ Product.PriceLevel }</div>
                </div>
              </td>
            </tr>
  
            <tr>
              <td>
                <div id={"ContractData_LeftContainer"}>
                  <div id={"ContractData_TicketNameHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["TicketName"]}:</b></div>

                  <div id={"ContractData_TicketName"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ Product.TicketName }</div>
                </div>
              </td>
            </tr>
  
            {connectionData}
            
            {fromToConnectionData}
  
            {viaConnectionData}

            {validInData}
  
            <tr>
              <td colSpan={5}>
                  <br/>
                  <br/>
                    <div id={"ContractDataPaymentHeadline"}>
                      <b>{Vas.Resources.Labels["MethodOfPaymentCustomer"]}</b>
                    </div>
                  <br/>
                  <br/>
                </td>
            </tr>
            <tr>
              <td>
                <div id={"ContractData_LeftContainer"}>
                  <div id={"ContractData_DepositorHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Depositor"]}:</b></div>

                  <div id={"ContractData_Depositor"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ Payment.AccountOwner }</div>
                </div>

                <div id={"ContractData_Empty"}></div>
              </td>
            </tr>        

            <tr>
              <td>
                <div id={"ContractData_LeftContainer"}>
                  <div id={"ContractData_NameOfBankHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["NameOfBank"]}:</b></div>

                  <div id={"ContractData_NameOfBank"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ Payment.BankName }</div>
                </div>

                <div id={"ContractData_Empty"}></div>

              </td>
            </tr>
  
            <tr>
              <td>
                <div id={"ContractData_LeftContainer"}>
                  <div id={"ContractData_IbanHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Iban"]}:</b></div>

                  <div id={"ContractData_Iban"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ '**' + Payment.Iban.substr(18, 4) }</div>
                </div>

                <div id={"ContractData_Empty"}></div>

              </td>
            </tr>
  
          </tbody>
        </table>);
      }

      return ( <div className="LoginContainer">

      <div className={"form orderSuccessForm"} style={{ Width:'560px' }}>
        <table>
          <thead>
            <tr>
              <th colSpan={2}><h2 id={"OrderSuccessHeader"}>{Vas.Resources.Labels["OrderSuccessfully"]}</h2></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={2} className={"HintOrderWorkingOn"}>
                {Vas.Resources.Labels["OrderWorkingOn"]}
              </td>
            </tr>
          </tbody>
        </table>

        {PersonalData}

        {PersonalDataLegalGuardian}

        {ContractData}
      
        {AccountOwnerData}
      </div>
    </div>);
    }
}
export default OrderSuccess;
